import { dataSourceKey } from 'utils/entities';
import { DATA_SOURCES } from 'utils/metrics';
import type { Breadcrumb, EntityDataOutput } from '../types';

export const formatDataSource = (source?: string): string => {
    if (!source) return '';
    // The tool's data_source is the API's name for it; utils/entities owns that
    // boundary, so the POPULARITY/pop_index mapping is not restated here.
    const key = dataSourceKey(source);
    return key && DATA_SOURCES[key] ? DATA_SOURCES[key].label : source;
};

export const formatGeoLabel = (geo?: string): string => {
    if (!geo) return '';
    if (geo.toLowerCase() === 'global') return 'Global';
    if (geo.toLowerCase() === 'gb') return 'UK';
    return geo;
};

export const buildBreadcrumb = (
    output: EntityDataOutput | undefined,
    typeLabel: string,
): Breadcrumb => ({
    geo: output?.result?.geo,
    dataSource: output?.result?.data_source,
    typeLabel,
});
